import { objectReducer } from 'utils'
import * as types from './types'

const { UPLOAD_PHOTO, UPLOAD_PHOTO_SUCCESS, UPLOAD_PHOTO_ERROR } = types

const myProfile = objectReducer(
  types.FETCH_MY_PROFILE,
  {},
  {
    extra: (state, { type }) => {
      if (type == UPLOAD_PHOTO) {
        return { ...state, uploading: true }
      }
      if (type == UPLOAD_PHOTO_SUCCESS || type == UPLOAD_PHOTO_ERROR) {
        return { ...state, uploading: false }
      }
      return state
    },
  }
)

export default myProfile
